//-------------------
// get action counts
//-------------------
export default function getActionCounts(
  round_actions,
  round_markers,
  combatant
) {
  // console.log("-----------------------------------");
  // console.log("getActionCounts for combatant " + combatant.name);
  //----------
  // set vars
  //----------
  let counts = {
    action_count: 0,
    actual_action_count: 0,
    marker_count: 0,
  };
  //-------------------------------------
  // filter actions/markers by combatant
  //-------------------------------------
  let combatant_actions = round_actions.filter((a) => a.combatant == combatant.id)
  let combatant_markers = round_markers.filter((a) => a.combatant == combatant.id)
  //---------------------------------------------------
  // set to_slot where actions/markers exist for round
  //---------------------------------------------------
  if (combatant_actions.length > 0 || combatant_markers.length > 0) {
    //---------------------------------
    // A. both actions + markers exist
    //---------------------------------
    if (combatant_actions.length > 0 && combatant_markers.length > 0) {
      // console.log("A. both actions + markers");
      counts.actual_action_count = combatant_actions[0].actual_action_count;
      counts.action_count = combatant_actions[0].action_count;
      counts.marker_count = combatant_markers[0].marker_count;
      //-----------------------
      // B. only actions exist
      //-----------------------
    } else if (combatant_actions.length > 0 && combatant_markers.length == 0) {
      // console.log("B. only actions");
      counts.actual_action_count = combatant_actions[0].actual_action_count;
      counts.action_count = combatant_actions[0].action_count;
      counts.marker_count = 0;
      //-----------------------
      // C. only markers exist
      //-----------------------
    } else {
      // console.log("C. only markers");
      counts.actual_action_count = 0;
      counts.action_count = 0;
      counts.marker_count = combatant_markers[0].marker_count;
    }
    //--------------------------------------
    // D. else to_slot = ca & counts = zero
    //--------------------------------------
  } else {
    // console.log("D. neither");
    counts.to_slot = combatant.ca;
    counts.actual_action_count = 0;
    counts.action_count = 0;
    counts.marker_count = 0;
  }
  return counts;
}
